import { useMemo } from "react";
import { convertBudgetToNumber, normalize } from "./commonHooks";
import { resolveCountryCode } from "../data/countries";

export default function usePropertiesFilter(
  properties,
  filterAgent,
  filterArea,
  filterCountry,
  minPrice,
  minPriceUnit,
  maxPrice,
  maxPriceUnit,
) {
  return useMemo(() => {
    const normalizedAgent = normalize(filterAgent);
    const normalizedArea = normalize(filterArea);
    const normalizedCountry = normalize(filterCountry);
    const minFilter = convertBudgetToNumber(minPrice, minPriceUnit);
    const maxFilter = convertBudgetToNumber(maxPrice, maxPriceUnit);
    const hasPriceFilter = minFilter !== "" || maxFilter !== "";

    return (properties || []).filter((property) => {
      const agentId = String(
        property.agent_id ?? property.agentId ?? property.agent?.id ?? "",
      );

      if (normalizedAgent !== "all" && normalize(agentId) !== normalizedAgent) {
        return false;
      }

      if (
        normalizedArea !== "all" &&
        normalize(property.area) !== normalizedArea
      ) {
        return false;
      }

      const propertyCountryCode = resolveCountryCode(property);

      if (
        normalizedCountry !== "all" &&
        normalize(propertyCountryCode) !== normalizedCountry
      ) {
        return false;
      }

      if (hasPriceFilter && normalizedCountry !== "all") {
        const propMin = Number(property.min_budget);
        const propMax = Number(property.max_budget);
        const hasBudget =
          Number.isFinite(propMin) || Number.isFinite(propMax);

        if (!hasBudget) return false;

        const rangeMin = Number.isFinite(propMin)
          ? propMin
          : Number.isFinite(propMax)
            ? propMax
            : 0;
        const rangeMax = Number.isFinite(propMax)
          ? propMax
          : rangeMin;

        if (minFilter !== "" && rangeMax < minFilter) return false;
        if (maxFilter !== "" && rangeMin > maxFilter) return false;
      }

      return true;
    });
  }, [
    properties,
    filterAgent,
    filterArea,
    filterCountry,
    minPrice,
    minPriceUnit,
    maxPrice,
    maxPriceUnit,
  ]);
}
